import './style.css';

import { GrStreetView } from "react-icons/gr";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

export default function Contact() {
  return (
    <div className="contact-container" id="Contact">
      <div className="contact-info">
        <h2 className="contact-title">Onde nos encontrar?</h2>
        <div className="contact-info-item">
          <GrStreetView className="contact-info-icon street"/>
          <span className="contact-info-text">Rua Eletricista, 1384, Residêncial 2000</span>
        </div>
        <div className="contact-info-item">
          <FaWhatsapp className="contact-info-icon whatsapp"/>
          <span className="contact-info-text"> &#40;42&#41; 9 8409-3699</span>
        </div>
        <div className="contact-info-item">
          <FaInstagram className="contact-info-icon instagram"/>
          <span className="contact-info-text">@salaodagehh</span>
        </div>
      </div>
      <div className="contact-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.4215003188106!2d-51.439410024955684!3d-25.357186327608293!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ef367dda9f4f21%3A0xdf14cfc4d0d7c0dc!2sR.%20dos%20Eletricistas%20-%20Im%C3%B3veis%20Morro%20Alto%2C%20Guarapuava%20-%20PR%2C%2085064-150!5e0!3m2!1spt-BR!2sbr!4v1739729722180!5m2!1spt-BR!2sbr"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Localização"
      />
      </div>
    </div>
  );
}